
class SocialVideo extends HTMLElement {
    constructor() {
        super();
        this.isMuted = true;
        this.previewSlider = null;
        this.fullSlider = null;
    }


    connectedCallback() {

        setTimeout(() => {

            
            const fullSliderWrapper = this.querySelector('.social-video__full-slider-wrapper');

            const playButton = this.querySelector('.social-video__full-slider-play-button');
            const soundButtons = this.querySelectorAll('.social-video__full-slider-sound-buttons');
            const unmuteIcon = this.querySelector('#unmute-button');
            const muteIcon = this.querySelector('#mute-button');
            const closeButton = this.querySelector('#close-button');
            const loadingIndicator = this.querySelector('.social-video__full-slider-loading-indicator');
            const fill = this.querySelector('.social-video__full-slider-progress-fill');         

            //Move full slider to the end of the body
            document.body.appendChild(fullSliderWrapper);

            this.previewSlider = new Swiper(".social-video__preview-slider", {
                spaceBetween: 10,
                slidesPerView: 1.2,
                breakpoints: {
                    768: {
                        slidesPerView: 2.2,
                    },
                    1024: {
                        slidesPerView: 3.2,
                    },
                    1200: {
                        slidesPerView: 4.2,
                    },
                },
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                },
            });



            this.fullSlider = new Swiper(".social-video__full-slider", {
                spaceBetween: 0,
                slidesPerView: 1,
                loop: true,
                direction: 'vertical',
                thumbs: {
                    swiper: this.previewSlider
                },
            });


            fullSliderWrapper.classList.add('social-video__full-slider-wrapper--hidden');
            this.fullSlider.update();


            const videos = document.querySelectorAll('.full-slider-video');
            const previewVideos = this.querySelectorAll('.social-video__preview-slider .thumbnail-video');

            previewVideos.forEach((video) => {
                //play and mute
                video.muted = true;
                video.play();
            });

            // Attach event listeners to each preview video
            this.previewSlider.slides.forEach(video => {
                video.addEventListener('click',  () => {

                    //pause all preview videos
                    previewVideos.forEach(video => video.pause());

                    fullSliderWrapper.classList.remove('social-video__full-slider-wrapper--hidden');
                    document.body.style.overflow = 'hidden';
                    this.fullSlider.slides[this.fullSlider.activeIndex].querySelector('.full-slider-video').play();
                });
            });

            // When the slide changes, pause all videos
            this.fullSlider.on('slideChange', () => {
                videos.forEach(video => video.pause());

                // Code for pre-buffering next few slides
                const upcomingIndexes = [this.fullSlider.activeIndex - 1, this.fullSlider.activeIndex + 1];
                upcomingIndexes.forEach(index => {
                    const video = this.fullSlider.slides[index]?.querySelector('.full-slider-video');
                    if (video && video.paused && video.readyState === 0) {
                        video.load();  // start loading video data
                    }
                });

                const activeSlide = this.fullSlider.slides[this.fullSlider.activeIndex];
                const activeVideo = activeSlide.querySelector('.full-slider-video');
                activeVideo.muted = this.isMuted;                
                activeVideo.play();
            });

            playButton.addEventListener('click', async function () {
                const activeVideo = [...videos].find(video => !video.paused);
                if (activeVideo) {
                    if (activeVideo.paused) {
                        try {
                            await activeVideo.play();
                            // If playback succeeds, hide the play button
                            playButton.style.display = 'none';
                        } catch (error) {
                            // Handle the error, e.g., log it or display a message
                            console.error("Playback failed:", error);
                        }
                    } else {
                        activeVideo.pause();
                        playButton.style.display = 'block'; // show play button when video is paused
                    }
                }
            });

            soundButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.isMuted = !this.isMuted;
                    if (this.isMuted) {
                        muteIcon.style.display = 'block';
                        unmuteIcon.style.display = 'none';
                    } else {
                        muteIcon.style.display = 'none';
                        unmuteIcon.style.display = 'block';
                    }

                    videos.forEach(video => video.muted = this.isMuted);

                    
                });
            });

            closeButton.addEventListener('click', function () {
                videos.forEach(video => video.pause());
                previewVideos.forEach(video => video.play());
                fullSliderWrapper.classList.add('social-video__full-slider-wrapper--hidden');
                document.body.style.overflow = '';
            });

            videos.forEach(video => {
                video.addEventListener('timeupdate', function () {
                    if (!this.paused) {
                        const percent = (this.currentTime / this.duration) * 100;
                        fill.style.width = percent + '%';
                    }
                });

                video.addEventListener('play', function () {
                    playButton.style.display = 'none'; // hide play button
                });

                video.addEventListener('pause', function () {
                    playButton.style.display = 'block'; // show play button
                });

                video.addEventListener('click', function () {
                    if (this.paused) {
                        this.play();
                    } else {
                        this.pause();
                    }
                });

                  // Listen for 'waiting' event when video is waiting for more data
                video.addEventListener('waiting', function() {
                    //if this is the currently active slide, show loading animation
                    if(this.parentElement.classList.contains('swiper-slide-active')) {
                        loadingIndicator.style.display = 'block';
                    }
                });

                video.addEventListener('playing', function() {
                    //if this is the currently active slide, hide loading animation
                    if(this.parentElement.classList.contains('swiper-slide-active')) {
                        loadingIndicator.style.display = 'none';
                    }
                });


            });            


            fullSliderWrapper.style.visibility = 'visible';


        });

    }


}

customElements.define('social-video', SocialVideo);
